// extracted by mini-css-extract-plugin
export default {"stars":"stars__PJy8h","starWrap":"starWrap__v9fNF","starBox":"starBox__XCxkF","hover":"hover__mpxrP","isSelected":"isSelected__0t1Yg","starSvg":"starSvg__9jCA8"};